import React from "react";
import { Link } from "react-router-dom";
import { LuChevronLeft } from "react-icons/lu";

interface PageHeaderProps {
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  back?: { label: string; to: string };
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, description, actions, back }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
    <div className="min-w-0">
      {back && (
        <Link
          to={back.to}
          className="mb-2 inline-flex items-center gap-1 rounded-control text-caption font-medium text-fg-muted hover:text-fg focus-visible:outline-none focus-visible:shadow-focus"
        >
          <LuChevronLeft size={14} aria-hidden />
          {back.label}
        </Link>
      )}
      <h1 className="break-words text-title-sm font-semibold text-fg sm:text-title">{title}</h1>
      {description && <p className="mt-1 text-body text-fg-muted">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);
